/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Row,
  Col,
  Spin,
  Card,
  Tabs,
  Result as AntResult,
  Button,
  DatePicker,
  Typography,
  Collapse,
  message,
  Space,
  Modal,
  Grid,
} from 'antd';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Table from 'components/Table';
import { onError } from 'utils/handlers';
import FormSubmitControls from 'components/FormSubmitControls';
import Direccion from 'components/Direccion';
import Select from 'components/Select';
import { model as modelPrediosKeys } from 'components/Catalogos/LlavesDePredios';
import {
  baseURI,
  getPredio,
  getPredios,
  patchPredio,
  postPredio,
} from 'api/catastro/predio';
import {
  getConfiguracionDeClave,
  getFactoresDeTraslado,
  getRegimenesDePropiedad,
  getTiposDeCuentasDePredios,
  getTiposDeLlavesDePredios,
  getTiposDeValuacion,
  getUsosDePredio,
  getTiposDePrediosUrbanos,
  getEtapasDePredios,
  getTiposDeAvaluo,
  getPavimentosDePredios,
  getZonasDePredios,
  getTipoDePredio,
} from 'api/catastro';
import NumericInput from 'components/NumericInput';
import { DATE_FRONTEND_FORMAT, DATETIME_FRONTEND_FORMAT, discartNullValues } from 'utils/formatValues';
import checkToken from 'api/utils/checkToken';
import {
  capitalize,
  decimalNormalizer,
  INTEGER_PATTERN,
  toInteger,
} from 'utils/normalizers';
import {
  DeleteOutlined,
  SearchOutlined,
  PrinterOutlined,
  HistoryOutlined,
} from '@ant-design/icons';
import Participes, { permissionParticipe } from 'components/Participes';
import { makeGetOnFinish, makeOnChangeTabKey } from 'utils/tabsManagement';
import makeMessager from 'utils/complexFormsMessages';
import { ESTADOS_GLOBALES_MAP, isMutable } from 'utils/estadosGlobales';
import useActualizadorDeCartera, { permissionConfigActionsActualizadorCartera } from 'hooks/useActualizadorDeCartera';
import ColindanciasDePredios, { permissionConfig as permissionConfigColindancias } from 'components/Catalogos/ColindanciasDePredios';
import AvaluoTerreno, { permissionConfig as permissionConfigAvaluoTerreno } from 'components/Catalogos/AvaluoTerreno';
import AvaluoConstrucciones, { permissionConfig as permissionConfigAvaluoConstrucciones } from 'components/Catalogos/AvaluoConstrucciones';
import AreasComunesDePredios, { permissionConfig as permissionAreasComunes } from 'components/Catalogos/AreasComunesDePredios';
import ValoresReferidosDePredios, { permissionConfig as permissionValoresReferidos } from 'components/Catalogos/ValoresReferidosDePredios';
import { postObtenerReporte } from 'api/reporteador';
import Previewer from 'components/Previewer';
import HistorialDeTramites from 'components/Catalogos/HistorialDeTramites';
import HistorialPrevioDeTramites from 'components/Catalogos/HistorialPrevioDeTramites';
import { getTiposDeDocumentosDeTraslaciones } from 'api/catalogos';
import { getUnidadesDeRecaudacion } from 'api/configuracion/unidadesDeRecaudacion';
import { logger } from 'utils/debug';
import { useSelector } from 'react-redux';
import getAllPages from 'utils/getAllPages';
import { getCatalogoPeritosDePredio } from 'api/catastro/peritosDePredios';
import { getCatalogoNotariosDePredios, getNotarioDePredio } from 'api/catastro/notariosDePredios';
import columnsPrediosOaxaca from './columnsPrediosOaxaca';
import { handleOnBlur } from './utils/onBlurKey';

const { TabPane } = Tabs;
const { Title, Text } = Typography;

const FormBusquedaControls = ({ handleSearch, wipe }) => (
  <>
    <Col xs={24} sm={24} md={8} lg={6}>
      <Button
        onClick={handleSearch}
        block
        style={{ marginTop: 21 }}
        icon={<SearchOutlined />}
      >
        Buscar
      </Button>
    </Col>
    <Col xs={24} sm={24} md={8} lg={6}>
      <Button
        onClick={wipe}
        block
        style={{ marginTop: 21 }}
        icon={<DeleteOutlined />}
      >
        Limpiar búsqueda
      </Button>
    </Col>
  </>
);

const CommonFieldsSearch = () => (
  <>
    <Col span={24}>
      <Collapse>
        <Collapse.Panel header="Por Dirección" key="1">
          <Row gutter={10}>
            <Col md={6} sm={24} xs={24}>
              <NumericInput
                label="Código postal"
                name="direccion__codigo_postal__d_codigo"
                maxLength={5}
              />
            </Col>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label="Calle principal" name="direccion__calle_principal" normalize={capitalize}>
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label="Número exterior" name="direccion__numero_exterior" normalize={capitalize}>
                <Input allowClear />
              </Form.Item>
            </Col>
          </Row>
        </Collapse.Panel>
        <Collapse.Panel header="Por Propietario" key="2">
          <Row gutter={10}>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label="RFC" name="rfc" normalize={capitalize}>
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label="CURP" name="curp" normalize={capitalize}>
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label="Razón Social" name="razon_social">
                <Input allowClear />
              </Form.Item>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label="Nombres de Participes" name="nombres_de_participes">
                <Input allowClear />
              </Form.Item>
            </Col>
          </Row>
        </Collapse.Panel>
      </Collapse>
    </Col>

  </>
);

const DefaultFieldsSearch = () => (
  <>
    <Col md={6} sm={24} xs={24}>
      <Form.Item label="Clave" name="clave" normalize={capitalize}>
        <Input allowClear />
      </Form.Item>
    </Col>
    <Col md={6} sm={24} xs={24}>
      <Form.Item label="No. Cuenta" name="clave_catastral_municipal" normalize={capitalize}>
        <Input allowClear />
      </Form.Item>
    </Col>
    <Col md={6} sm={24} xs={24}>
      <Form.Item label="Clave Catastral Estándar" name="clave_catastral_estandar" normalize={capitalize}>
        <Input allowClear />
      </Form.Item>
    </Col>
  </>
);

const Simbologia = () => (
  <Row style={{ marginBlock: 10 }}>
    <Text>Simbología</Text>
    <Col span={24} style={{ display: 'flex', alignItems: 'center' }}>
      <div
        className="danger-row"
        style={{ height: 20, width: 20, marginRight: 5 }}
      />
      <Text>Cancelado / Tiene alertas restrictivas</Text>
    </Col>
    <Col span={24} style={{ display: 'flex', alignItems: 'center' }}>
      <div
        className="warning-row"
        style={{ height: 20, width: 20, marginRight: 5 }}
      />
      <Text>Trámite en proceso / Tiene alertas informativas</Text>
    </Col>
  </Row>
);

export const catalogsModels = [
  'regimendepropiedad',
  'tipodepredio',
  'usodepredio',
  'clavedepredio',
  'zonadepredio',
  'clasedeaseo',
  'tipodeaseo',
  modelPrediosKeys,
];

const customActions = [
  {
    name: 'changecrud_predio',
    title: 'Modificar predio en CRUD',
    permissions: ['changecrud_predio'],
  },
  {
    name: 'editar_valores_y_medidas',
    title: 'Editar valores y medidas',
    permissions: ['editar_valores_y_medidas'],
  },
  {
    name: 'editar_tab_general',
    title: 'Editar tab general',
    permissions: ['editar_tab_general', 'changecrud_predio'],
  },
  {
    name: 'editar_tab_servicios',
    title: 'Editar tab servicios',
    permissions: ['editar_tab_servicios', 'changecrud_predio'],
  },
  {
    name: 'editar_tab_transmision',
    title: 'Editar tab transmisión patrimonial',
    permissions: ['editar_tab_transmision', 'changecrud_predio'],
  },
  {
    name: 'editar_area_titulo',
    title: 'Editar área título',
    permissions: ['editar_area_titulo'],
  },
  permissionConfigActionsActualizadorCartera.find((e) => e.padron === 3),
];

export const permissionConfig = {
  permissionModel: 'predio',
  customActions,
  catalogsModels,
  tabsModels: [
    permissionParticipe,
    permissionConfigColindancias,
    permissionConfigAvaluoTerreno,
    permissionConfigAvaluoConstrucciones,
    permissionAreasComunes,
    permissionValoresReferidos,
  ],
};

const Predios = ({ permission: _permission, addressPermission }) => {
  const permission = { ..._permission, change: _permission.changecrud_predio };
  const user = useSelector((s) => s.auth.user);
  const history = useHistory();
  const [formSearch] = Form.useForm();
  const [form] = Form.useForm();
  const [formColindancias] = Form.useForm();
  const [formServicios] = Form.useForm();
  const [formTraslado] = Form.useForm();
  const [formValoresMedidas] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({ results: [] });
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [mutable, setMutable] = useState(true);
  const [regimenDePropiedad, setRegimenDePropiedad] = useState([]);
  const [configuracionesDeClavesDePredios, setConfiguracionesDeClavesDePredios] = useState([]);
  const [clavesDePredios, setClavesDePredios] = useState([]);
  const [usosDePredio, setUsosDePredio] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [zonasDePredios, setZonasDePredios] = useState([]);
  const [tiposDeDocumentos, setTiposDeDocumentos] = useState([]);
  const [notarios, setNotarios] = useState([]);
  const [formAddress, setFormAddress] = useState(null);
  const [formAddressNotificacion, setFormAddressNotificacion] = useState(null);
  const [searchParams, setSearchParams] = useState({});
  const [selectedPredio, setSelectedPredio] = useState();
  const [base64, setBase64] = useState();
  const [verHistorial, setVerHistorial] = useState(false);
  const [verHistorialPrevio, setVerHistorialPrevio] = useState(false);
  const [predioSelected, setPredioSelected] = useState({});
  const { confirmUpdateCartera, updateCarteraAvailable } = useActualizadorDeCartera({
    tipoDePadronId: 3,
    padron: predioSelected,
    setLoading,
    permission,
  });
  const screens = Grid.useBreakpoint();
  const [factoresDeTraslado, setFactoresDeTraslado] = useState([]);
  const [tiposDeValuacion, setTiposDeValuacion] = useState([]);
  const [tiposDeCuentas, setTiposDeCuentas] = useState([]);
  const [tiposDePrediosUrbanos, setTiposDePrediosUrbanos] = useState([]);
  const [unidadesRecaudadoras, setUnidadesRecauadoras] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const [tiposDeAvaluo, setTiposDeAvaluo] = useState([]);
  const [peritos, setPeritos] = useState([]);
  const [pavimentos, setPavimentos] = useState([]);
  const [tiposDePredios, setTiposDePredios] = useState([]);

  const formInstances = [
    form,
    formColindancias,
    formServicios,
    formTraslado,
    formValoresMedidas,
  ];

  const complexForms = [
    { key: 'direccion', formInstance: formAddress, permission: addressPermission },
    { key: 'direccion_notificacion', formInstance: formAddressNotificacion, permission: addressPermission },
  ];

  const basicKeys = [
    'general',
    'traslado',
    'servicios',
    'valoresMedidas',
  ];

  const fetchData = async (page = 1, params = null) => {
    setLoading(true);
    setCurrentPage(page);
    const _data = await getPredios({ page, ...params, ...searchParams });
    _data.params = params;
    setData(_data);
    setLoading(false);
  };

  const showMsg = makeMessager(setCurrentTabKey, fetchData);

  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys,
    complexForms,
    currentTabKey,
    setCurrentTabKey,
    showMsg,
    mutable,
  );

  useEffect(() => {
    let mounted = true;
    checkToken();
    const fetchAll = async () => {
      setLoading(true);
      const [
        _regimenDePropiedad,
        _usoDePredio,
        _clavesDePredios,
        _llaves,
        _tiposDeDocumentos,
        _notarios,
        _factoresDeTraslado,
        _tiposDeValuacion,
        _tiposDeCuentas,
        _unidadesRecaudadoras,
        _tiposDePredios,
        _zonasDePredios,
        _tiposDePrediosUrbanos,
        _etapas,
        _tiposDeAvaluo,
        _peritos,
        _pavimentos,
      ] = await Promise.all([
        getRegimenesDePropiedad(),
        getUsosDePredio(),
        getTiposDeLlavesDePredios(),
        getConfiguracionDeClave({ estados_globales: 4 }),
        getTiposDeDocumentosDeTraslaciones(),
        getAllPages(getCatalogoNotariosDePredios),
        getFactoresDeTraslado(),
        getTiposDeValuacion(),
        getTiposDeCuentasDePredios(),
        getUnidadesDeRecaudacion(),
        getTipoDePredio(),
        getZonasDePredios(), // getZonas(),
        getTiposDePrediosUrbanos(),
        getEtapasDePredios(),
        getTiposDeAvaluo(),
        getAllPages(getCatalogoPeritosDePredio),
        getPavimentosDePredios(),
      ]);

      if (mounted) {
        setRegimenDePropiedad(_regimenDePropiedad);
        setUsosDePredio(_usoDePredio);
        setClavesDePredios(_clavesDePredios);
        if (_llaves.length && _llaves.some((e) => e.es_principal === true)) {
          setConfiguracionesDeClavesDePredios(_llaves);
        }
        setZonasDePredios(_zonasDePredios);
        setTiposDeDocumentos(_tiposDeDocumentos);
        setNotarios(_notarios);
        setFactoresDeTraslado(_factoresDeTraslado);
        setTiposDeValuacion(_tiposDeValuacion);
        setTiposDeCuentas(_tiposDeCuentas);
        setTiposDePrediosUrbanos(_tiposDePrediosUrbanos);
        setUnidadesRecauadoras(_unidadesRecaudadoras);
        setEtapas(_etapas);
        setTiposDeAvaluo(_tiposDeAvaluo);
        setPeritos(_peritos);
        setPavimentos(_pavimentos);
        setTiposDePredios(_tiposDePredios);
        setLoading(false);
        if (process.env.NODE_ENV === 'development') await fetchData();
      }
    };

    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setVisible(false);
    // setCurrentPredio(null);
    setCurrentPage(1);
    formInstances.forEach((formInstance) => formInstance.resetFields());
    setSelectedRowKeys([]);
    setCurrentTabKey('general');
    setMutable(true);
    setData({ results: [] });
    setSelectedPredio();
  };

  const validateIfEditable = async (predio) => {
    message.destroy();
    if (predio?.alerta?.length) {
      const hasAlertasRestrictivas = predio?.alerta?.some((e) => e.es_restrictiva);

      message.warn({
        content: (
          <div style={{ textAlign: 'left' }}>
            <Title level={5} style={{ textAlign: 'center' }}>
              El predio tiene alertas
              {' '}
              {hasAlertasRestrictivas && 'restrictivas'}
            </Title>
            <Space direction="vertical" size="small" style={{ display: 'flex' }}>
              <ul style={{ paddingLeft: 20 }}>
                {predio?.alerta?.map((e) => (
                  <li key={e.id}>
                    <Text>{e.descripcion}</Text>
                    <br />
                    <Text type="secondary">{e.observaciones}</Text>
                  </li>
                ))}
              </ul>
              {hasAlertasRestrictivas && (
                <Text strong>Debe de pasar a Catastro</Text>
              )}
            </Space>
          </div>
        ),
      });

      return false;
    }

    // if (predio?.json_predio || predio?.estados_globales === ESTADOS_GLOBALES_MAP.EN_PROCESO) {
    //   message.warn('Edición no permitida: el predio tiene un TRAMITE con estado EN PROCESO');
    //   setLoading(false);
    //   return false;
    // }

    setLoading(false);
    return true;
  };

  const handleOnRowClick = async (_record) => {
    const record = discartNullValues(_record);
    const isvalid = await validateIfEditable(record);
    if (!isvalid) {
      setSelectedRowKeys([]);
      return;
    }
    setSelectedRowKeys([record.id]);
  };

  const selectedPredioRow = data?.results?.find((e) => e.id === selectedRowKeys[0]);
  const isSelectedPredioCancelado = selectedPredioRow?.estados_globales
    === ESTADOS_GLOBALES_MAP.CANCELADO;

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const setCiudadanoData = (ciudadano) => {
    if (ciudadano) {
      const {
        nombre_completo,
        CURP,
        RFC,
      } = ciudadano;
      form.setFieldsValue({
        nombres_de_participes: nombre_completo,
        curp: CURP,
        rfc: RFC,
      });
    }
  };

  const setContribuyenteData = (contribuyente) => {
    if (contribuyente) {
      const { razon_social, rfc } = contribuyente;
      form.setFieldsValue({
        nombres_de_participes: razon_social,
        rfc,
      });
    }
  };

  const setFormData = (predio) => {
    formInstances.forEach((formInstance) => {
      formInstance.resetFields();
      formInstance.setFieldsValue({
        ...predio,
        factor_merito_demerito: predio.factor_merito_demerito === 0
          ? null : predio.factor_merito_demerito,
      });
    });
    if (predio?.tipo_de_predio) {
      form.setFieldsValue({ tipo_de_predio: predio.tipo_de_predio.id });
    }
    setLoading(false);
  };

  const onClickEdit = async (_key) => {
    try {
      setLoading(true);
      const key = selectedRowKeys[0] || _key;
      const _predio = await getPredio(key);
      setPredioSelected(_predio);
      if (!_predio) {
        message.error('No se pudo obtener la información del predio');
        return;
      }
      const predio = discartNullValues(_predio);
      if (predio?.contribuyente) setContribuyenteData(predio.contribuyente);
      if (predio?.ciudadano) setCiudadanoData(predio.ciudadano);

      setFormData(predio);
      setVisible(true);
      setMutable(isMutable(predio) && !predio.json_predio && permission.change);
      setSelectedPredio(predio);
    } catch (error) {
      logger(error);
      message.error('Ocurrió un error al intentar editar el predio');
    } finally {
      setLoading(false);
    }
  };

  const onClickExpand = async () => {
    await onClickEdit();
    setMutable(false);
  };

  const handleSearch = async () => {
    try {
      setLoading(true);
      await formSearch.validateFields();
      const paramsSearch = formSearch.getFieldsValue();
      const keys = Object.keys(discartNullValues(paramsSearch));
      if (!keys.length) {
        setData({ results: [] });
        throw new Error('Ingrese al menos un campo para realizar la búsqueda');
      }

      const _data = await getPredios(paramsSearch);
      _data.params = paramsSearch;
      setData(_data);
      setSearchParams(paramsSearch);
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const wipe = () => {
    formSearch.resetFields();
    setSearchParams({});
    setData({ results: [] });
  };

  const onFinish = async (_continue = false) => {
    if (!mutable) return null;
    try {
      await form.validateFields();
      const values = formInstances.reduce((acc, formInstance) => {
        const formValues = formInstance.getFieldsValue();
        return { ...acc, ...formValues };
      }, {});
      delete values.tasa;
      delete values.valor_catastral;
      const [key] = selectedRowKeys;
      if (!values.factor_merito_demerito) {
        values.factor_merito_demerito = 0;
      }
      const saved = await (key ? patchPredio(key, values, false) : postPredio(values));
      if (saved) {
        if (_continue) {
          await onClickEdit(saved.id);
          if (!key) setTimeout(() => setSelectedRowKeys([saved.id]));
        }
        if (updateCarteraAvailable) {
          confirmUpdateCartera(_continue ? null : onCancel);
        } else if (!_continue) {
          onCancel();
        }
        return saved;
      }
      return null;
    } catch (error) {
      onError(error, setLoading, formInstances, setCurrentTabKey);
    } finally {
      setLoading(false);
    }
    return null;
  };

  const getOnFinish = makeGetOnFinish(basicKeys, complexForms, currentTabKey, onFinish);

  const getKeyRules = (conf) => [
    { required: conf.es_requerido },
    {
      validator: async (_, value) => {
        if (!value) return;
        const _message = 'El campo debe contener {MSG} caracteres';
        if (conf.longitud_minima === conf.longitud_maxima
          && value.length !== conf.longitud_minima) {
          throw new Error(_message.replace('{MSG}', conf.longitud_minima));
        }
        if (value.length < conf.longitud_minima) {
          throw new Error(_message.replace('{MSG}', `mínimo ${conf.longitud_minima}`));
        }
        if (value.length > conf.longitud_maxima) {
          throw new Error(_message.replace('{MSG}', `máximo ${conf.longitud_maxima}`));
        }
        if (!conf.es_alfanumerica && !INTEGER_PATTERN.test(value)) {
          throw new Error('El campo solo puede tener números');
        }
      },
    },
  ];

  const onUpdatePredio = () => onClickEdit();

  const imprimirFicha = async () => {
    setLoading(true);
    const values = {
      ID: 1007,
      Parametros: [
        {
          Nombre: 'predio',
          TipoParametro: 'Entero',
          Valor: selectedRowKeys[0],
        },
      ],
    };
    const _base64 = await postObtenerReporte(values);
    if (_base64) setBase64(_base64);
    setLoading(false);
  };
  const rules = { required: [{ required: true }] };

  const onChangeNotario = async (id) => {
    if (!id) {
      formTraslado.resetFields(['lugar_notaria']);
      return;
    }
    const notario = await getNotarioDePredio(id);
    const municipio = notario?.direcciones?.codigo_postal?.municipio?.nom_mun;
    if (municipio) formTraslado.setFieldValue('lugar_notaria', municipio);
  };

  return (
    <Row align="center" justify="center" className="container">
      <Col xs={24} sm={24} md={24}>
        <Spin tip="Cargando..." spinning={loading} style={{ width: '100%', height: '100%' }}>
          {!visible ? (
            <>
              <Form
                layout="vertical"
                form={formSearch}
                scrollToFirstError
                onFinish={() => handleSearch()}
                className="without-feedback"
              >
                <Row gutter={10}>
                  <DefaultFieldsSearch />
                  <CommonFieldsSearch />
                  <FormBusquedaControls handleSearch={handleSearch} wipe={wipe} />
                </Row>
                <Form.Item hidden>
                  <Button htmlType="submit" />
                </Form.Item>
              </Form>
              {!!configuracionesDeClavesDePredios.length && (
                <Row>
                  <br />
                  <Simbologia />
                  <Table
                    cols={columnsPrediosOaxaca}
                    mobileCols={[columnsPrediosOaxaca[1] || columnsPrediosOaxaca[0]]}
                    data={data?.results}
                    rowSelection={rowSelection}
                    handleOnRowClick={handleOnRowClick}
                    allowExpand
                    editDisabled={isSelectedPredioCancelado}
                    editDisabledTooltip="Edición no permitida: el predio está CANCELADO"
                    controls={{
                      onClickEdit,
                      onClickAdd,
                      onClickExpand,
                    }}
                    customActions={[
                      {
                        icon: <PrinterOutlined />,
                        text: 'Ficha',
                        onClick: imprimirFicha,
                      },
                      {
                        text: 'Historial',
                        icon: <HistoryOutlined />,
                        tooltip: 'Ver historial',
                        disabledBySelection: true,
                        onClick: () => setVerHistorial(true),
                      },
                      {
                        text: 'Historial previo',
                        icon: <HistoryOutlined />,
                        tooltip: 'Ver historial previo',
                        disabledBySelection: true,
                        onClick: () => setVerHistorialPrevio(true),
                      },
                    ]}
                    rowClassName={({ json_predio, alerta, estados_globales }) => {
                      let output = '';
                      if ((alerta?.length && alerta.some((e) => e.es_restrictiva))
                        || estados_globales === ESTADOS_GLOBALES_MAP.CANCELADO) {
                        output = 'danger-row';
                      }

                      if ((alerta?.length && alerta.some((e) => !e.es_restrictiva))
                        || json_predio || estados_globales === ESTADOS_GLOBALES_MAP.EN_PROCESO) {
                        output = `${output} warning-row`;
                      }

                      return output;
                    }}
                    rowKey="id"
                    count={data?.count}
                    hasAllViewPermission
                    permission={permission}
                    pagination={false}
                    paginationCallback={(p) => fetchData(p, data.params)}
                    currentPage={currentPage}
                  />
                </Row>
              )}
              {!loading && !configuracionesDeClavesDePredios.length && (
                <Result
                  title="Se requiere la configuración de llaves de predios"
                  extra={permission.catalogs[modelPrediosKeys]?.view ? (
                    <Button onClick={() => history.push('/configuracion/entidad?tab=llavesDePredios')}>
                      Ir a Configuración de llaves de predios
                    </Button>
                  ) : null}
                />
              )}
            </>
          ) : (
            <Col span={24} style={{ height: '100%' }}>
              <Card
                className="form-container no-padding"
                title={selectedPredio ? selectedPredio.clave_catastral_municipal : 'Predio'}
                extra={(
                  <FormSubmitControls
                    onCancel={onCancel}
                    mutable={mutable}
                    allowSaveAndContinue
                    onFinish={permission.change ? getOnFinish() : null}
                  />
                )}
                bordered={false}
              >
                <Tabs
                  onChange={onChangeTabKey}
                  activeKey={currentTabKey}
                  type="card"
                >
                  <TabPane tab="General" key="general">
                    <Form
                      layout="vertical"
                      form={form}
                      scrollToFirstError
                      initialValues={{
                        estados_globales: 1,
                        recaudadora: user.unidad_de_recaudacion,
                      }}
                      name="general"
                      onFinish={permission.change ? () => onFinish() : null}
                    >
                      <Row gutter={10}>
                        {configuracionesDeClavesDePredios.map((config) => {
                          const clave = clavesDePredios
                            .find((e) => e.id === config.clave_de_predio);
                          return (
                            <Col xs={24} sm={24} md={8} key={clave.clave}>
                              <Form.Item
                                name={clave.clave}
                                label={clave.descripcion}
                                rules={getKeyRules(config)}
                                normalize={config.es_alfanumerica ? null : (v) => toInteger(v)}
                              >
                                <Input
                                  maxLength={config.longitud_maxima}
                                  onBlur={() => handleOnBlur(form)}
                                  allowClear
                                  disabled={!permission.editar_tab_general || !mutable}
                                />
                              </Form.Item>
                            </Col>
                          );
                        })}
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            label="Tipo de predio"
                            name="tipo_de_predio"
                            rules={rules.required}
                          >
                            <Select
                              dataSource={tiposDePredios}
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        {!!selectedRowKeys.length && (
                          <Col xs={24} sm={24} md={16}>
                            <Form.Item
                              name="participe_principal"
                              label="Propietario"
                            >
                              <Input
                                allowClear
                                disabled={!permission.editar_tab_general || !mutable}
                              />
                            </Form.Item>
                          </Col>
                        )}
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_predio_urbano"
                            label="Tipo de predio urbano"
                            rules={rules.required}
                          >
                            <Select
                              dataSource={tiposDePrediosUrbanos}
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="regimen_de_propiedad"
                            label="Tipo de propiedad"
                          >
                            <Select
                              dataSource={regimenDePropiedad}
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="uso_de_predio"
                            label="Uso de suelo"
                            rules={rules.required}
                          >
                            <Select
                              dataSource={usosDePredio}
                              onChange={(uso_de_predio) => formTraslado
                                .setFieldsValue({ uso_de_predio })}
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="es_ejidal"
                            label="¿Es ejidal?"
                          >
                            <Select
                              trueFalse
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="etapa"
                            label="Etapa"
                          >
                            <Select
                              dataSource={etapas}
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="clave_inegi"
                            label="Clave INEGI"
                          >
                            <Input
                              allowClear
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="subpredio"
                            label="Subpredio"
                          >
                            <Input
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="recaudadora"
                            label="Recaudadora"
                            rules={rules.required}
                          >
                            <Select
                              dataSource={selectedRowKeys.length ? unidadesRecaudadoras
                                : unidadesRecaudadoras.filter((u) => u.corresponde_usuario)}
                              disabled={!!selectedRowKeys.length}
                              labelProp="clave"
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="zona"
                            label="Zona catastral"
                          >
                            <Select
                              dataSource={zonasDePredios}
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Typography.Title level={4}>
                            Detalle
                          </Typography.Title>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_valuacion"
                            label="Tipo de valuación"
                          >
                            <Select
                              dataSource={tiposDeValuacion}
                              disabled={!permission.editar_tab_general || !mutable}
                              onChange={(tipo_de_valuacion) => formTraslado
                                .setFieldsValue({ tipo_de_valuacion })}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="fecha_visita"
                            label="Fecha visita"
                          >
                            <DatePicker
                              placeholder=""
                              format={DATETIME_FRONTEND_FORMAT}
                              showTime
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="perito_contribuyente"
                            label="Perito"
                          >
                            <Select
                              dataSource={peritos}
                              disabled={!permission.editar_tab_general || !mutable}
                              keyLabelRender
                              labelProp="nombre_completo"
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="responsable_cartografia"
                            label="Responsable cartografía"
                          >
                            <Input
                              allowClear
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="numero_de_avaluo"
                            label="Número de avaluo"
                          >
                            <Input
                              allowClear
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            name="notas_adicionales"
                            label="Notas"
                          >
                            <Input.TextArea
                              allowClear
                              autoSize={{ minRows: 3 }}
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            name="observaciones"
                            label="Observaciones"
                          >
                            <Input.TextArea
                              allowClear
                              autoSize={{ minRows: 3 }}
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={24} />
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tiene_cartografia"
                            label="¿Tiene cartografía?"
                          >
                            <Select
                              trueFalse
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="avaluo_externo"
                            label="Avaluo externo"
                          >
                            <Select
                              trueFalse
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="predio_con_accesorios"
                            label="Predio con accesorios"
                          >
                            <Select
                              trueFalse
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tasa_baldio"
                            label="Tasa baldio"
                          >
                            <Select
                              trueFalse
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="es_manifestacion_voluntaria"
                            label="¿Es manifestación voluntaria?"
                          >
                            <Select
                              trueFalse
                              disabled={!permission.editar_tab_general || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Form.Item name="clave" hidden><Input /></Form.Item>
                        <Form.Item hidden><Button htmlType="submit" /></Form.Item>
                      </Row>
                    </Form>
                  </TabPane>
                  {permission.tabs[permissionParticipe.model].hasAllViewPermission && (
                    <TabPane
                      tab="Participes"
                      key="participes"
                      forceRender={!!selectedPredio}
                      disabled={!selectedPredio}
                    >
                      <Participes
                        predio={selectedPredio}
                        permission={permission.tabs[permissionParticipe.model]}
                        callback={onClickEdit}
                        mutable={mutable}
                      />
                    </TabPane>
                  )}
                  <TabPane tab="Valores y medidas" key="valoresMedidas">
                    <Form
                      layout="vertical"
                      form={formValoresMedidas}
                      scrollToFirstError
                      initialValues={{ estados_globales: 1 }}
                      name="valoresMedidas"
                      onFinish={permission.editar_valores_y_medidas ? () => onFinish() : null}
                    >
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            label="Superficie de terreno"
                            name="superficie_total_del_terreno"
                            precision={3}
                            disabled={!permission.editar_area_titulo || !mutable}
                            decimal
                            commas
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            label="Valor terreno"
                            name="valor_del_terreno"
                            precision={3}
                            disabled={!permission.editar_area_titulo || !mutable}
                            decimal
                            currency
                            commas
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            label="Área Título"
                            name="area_titulo"
                            onChange={(area_titulo) => formTraslado.setFieldValue({ area_titulo })}
                            precision={3}
                            decimal
                            disabled={!permission.editar_area_titulo || !mutable}
                            commas
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            label="Superficie Construcción"
                            name="superficie_de_la_construccion"
                            precision={3}
                            disabled={!permission.editar_area_titulo || !mutable}
                            decimal
                            commas
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            label="Valor Construcción"
                            name="valor_de_la_construccion"
                            precision={3}
                            disabled={!permission.editar_area_titulo || !mutable}
                            decimal
                            currency
                            commas
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            label="Valor fiscal"
                            name="valor_catastral"
                            precision={3}
                            disabled={!permission.editar_area_titulo || !mutable}
                            decimal
                            currency
                            commas
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            label="Tasa"
                            name="tasa"
                            disabled={!permission.editar_area_titulo || !mutable}
                            decimal
                            precision={6}
                            commas
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            label="Frente"
                            name="frente"
                            precision={2}
                            decimal
                            commas
                            disabled={!permission.editar_valores_y_medidas || !mutable}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            label="Indiviso"
                            name="indiviso"
                            precision={8}
                            decimal
                            commas
                            disabled={!permission.editar_valores_y_medidas || !mutable}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            label="Profundidad"
                            name="profundidad"
                            precision={2}
                            decimal
                            commas
                            disabled={!permission.editar_valores_y_medidas || !mutable}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            label="Perímetro"
                            name="perimetro"
                            precision={2}
                            decimal
                            commas
                            disabled={!permission.editar_valores_y_medidas || !mutable}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            label="Demérito"
                            name="factor_merito_demerito"
                            precision={2}
                            decimal
                            commas
                            disabled={!permission.editar_valores_y_medidas || !mutable}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            label="Porcentaje Demérito"
                            name="porcentaje_demerito"
                            min={0}
                            max={100}
                            precision={4}
                            decimal
                            commas
                            disabled={!permission.editar_valores_y_medidas || !mutable}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            label="Motivo Demérito"
                            name="motivo_demerito"
                          >
                            <Input
                              allowClear
                              disabled={!permission.editar_valores_y_medidas || !mutable}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </TabPane>
                  {addressPermission.view && (
                    <>
                      <TabPane
                        tab="Ubicación del Inmueble"
                        key="direccion"
                        forceRender={!!selectedRowKeys?.length}
                        disabled={!selectedRowKeys.length}
                      >
                        <Direccion
                          setFormAddress={setFormAddress}
                          currentURI={baseURI}
                          parentID={selectedRowKeys[0]}
                          setLoading={setLoading}
                          setCurrentTabKey={setCurrentTabKey}
                          addressPropName="direccion"
                          callback={(values, _continue) => {
                            if (!_continue) {
                              onCancel();
                            } else {
                              const [key] = selectedRowKeys;
                              const clone = [...data.results];
                              const results = clone.map((e) => (e.id === key
                                ? ({ ...e, direccion: values?.id }) : e));
                              setData({ ...data, results });
                            }
                          }}
                          permission={addressPermission}
                          mutable={mutable && permission.change}
                        />
                      </TabPane>
                      <TabPane
                        tab="Dirección Notificación"
                        key="direccion_notificacion"
                        forceRender={!!selectedRowKeys?.length}
                        disabled={!selectedRowKeys.length}
                      >
                        <Direccion
                          setFormAddress={setFormAddressNotificacion}
                          currentURI={baseURI}
                          parentID={selectedRowKeys[0]}
                          setLoading={setLoading}
                          setCurrentTabKey={setCurrentTabKey}
                          addressPropName="direccion_notificacion"
                          callback={(values, _continue) => {
                            if (!_continue) {
                              onCancel();
                            } else {
                              const [key] = selectedRowKeys;
                              const clone = [...data.results];
                              const results = clone.map((e) => (e.id === key
                                ? ({ ...e, direccion_notificacion: values?.id }) : e));
                              setData({ ...data, results });
                            }
                          }}
                          permission={addressPermission}
                          mutable={mutable && permission.change}
                        />
                      </TabPane>
                    </>
                  )}
                  {permission.tabs[permissionConfigAvaluoTerreno.model]?.view && (
                    <TabPane
                      tab="Bloques de Terreno"
                      key="avaluoTerreno"
                      forceRender={!!selectedPredio}
                      disabled={!selectedPredio}
                    >
                      <AvaluoTerreno
                        mutable={mutable}
                        predio={selectedPredio}
                        permission={permission.tabs[permissionConfigAvaluoTerreno.model]}
                        onUpdatePredio={onUpdatePredio}
                        changePredioPermission={permission.changecrud_predio}
                      />
                    </TabPane>
                  )}
                  {permission.tabs[permissionConfigAvaluoConstrucciones.model]?.view && (
                    <TabPane
                      tab="Bloques de Construcciones"
                      key="construcciones"
                      forceRender={!!selectedPredio}
                      disabled={!selectedPredio}
                    >
                      <AvaluoConstrucciones
                        mutable={mutable}
                        predio={selectedPredio}
                        permission={permission.tabs[permissionConfigAvaluoTerreno.model]}
                        onUpdatePredio={onUpdatePredio}
                        changePredioPermission={permission.changecrud_predio}
                      />
                    </TabPane>
                  )}
                  {permission.tabs[permissionAreasComunes.model]?.view && (
                    <TabPane
                      tab="Áreas Comunes"
                      key="areasComunes"
                      forceRender={!!selectedPredio}
                      disabled={!selectedPredio}
                    >
                      <AreasComunesDePredios
                        mutable={mutable}
                        predio={selectedPredio}
                        permission={permission.tabs[permissionAreasComunes.model]}
                      />
                    </TabPane>
                  )}
                  {permission.tabs[permissionValoresReferidos.model]?.view && (
                    <TabPane
                      tab="Valores Referidos"
                      key="valoresReferidos"
                      forceRender={!!selectedPredio}
                      disabled={!selectedPredio}
                    >
                      <ValoresReferidosDePredios
                        mutable={mutable}
                        predio={selectedPredio}
                        permission={permission.tabs[permissionValoresReferidos.model]}
                      />
                    </TabPane>
                  )}
                  {permission.tabs[permissionConfigColindancias.model]?.view && (
                    <TabPane
                      tab="Medidas y linderos"
                      key="colindancias"
                      forceRender={!!selectedRowKeys.length}
                      disabled={!selectedRowKeys.length}
                    >
                      <ColindanciasDePredios
                        mutable={mutable}
                        predio={selectedPredio}
                        permission={permission.tabs[permissionConfigColindancias.model]}
                        onUpdatePredio={onUpdatePredio}
                        changePredioPermission={permission.changecrud_predio}
                      />
                    </TabPane>
                  )}
                  <TabPane tab="Servicios" key="servicios" forceRender>
                    <Form
                      layout="vertical"
                      form={formServicios}
                      scrollToFirstError
                      name="servicios"
                      onFinish={() => onFinish()}
                    >
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tiene_servicio_de_agua"
                            label="Agua"
                          >
                            <Select
                              trueFalse
                              disabled={!permission.editar_tab_servicios || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tiene_alumbrado"
                            label="Alumbrado"
                          >
                            <Select
                              trueFalse
                              disabled={!permission.editar_tab_servicios || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tiene_banqueta"
                            label="Banqueta"
                          >
                            <Select
                              trueFalse
                              disabled={!permission.editar_tab_servicios || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tiene_drenaje"
                            label="Drenaje"
                          >
                            <Select
                              trueFalse
                              disabled={!permission.editar_tab_servicios || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tiene_electricidad"
                            label="Electricidad"
                          >
                            <Select
                              trueFalse
                              disabled={!permission.editar_tab_servicios || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tiene_telefono"
                            label="Teléfono"
                          >
                            <Select
                              trueFalse
                              disabled={!permission.editar_tab_servicios || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="pavimento"
                            label="Pavimento"
                          >
                            <Select
                              dataSource={pavimentos}
                              disabled={!permission.editar_tab_servicios || !mutable}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Form.Item hidden>
                        <Button htmlType="submit" />
                      </Form.Item>
                    </Form>
                  </TabPane>
                  <TabPane tab="Transmisión Patrimonial" key="traslado" forceRender>
                    <Form
                      layout="vertical"
                      form={formTraslado}
                      scrollToFirstError
                      name="traslado"
                      onFinish={() => onFinish()}
                    >
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_avaluo"
                            label="Tipo de avaluo"
                          >
                            <Select
                              dataSource={tiposDeAvaluo}
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        {/* <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="avaluo_comercial_traslado"
                            label="Número de Avalúo"
                          >
                            <Input allowClear />
                          </Form.Item>
                        </Col> */}
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_documento_traslado"
                            label="Acto de transmisión"
                          >
                            <Select
                              dataSource={tiposDeDocumentos}
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="escritura"
                            label="Número de escritura pública"
                          >
                            <Input
                              allowClear
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="lugar_notaria"
                            label="Lugar de otorgamiento"
                          >
                            <Input disabled={!permission.editar_tab_transmision || !mutable} />
                          </Form.Item>
                        </Col>
                        {/* <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="precio_pactado_traslado"
                            label="Valor de la transmisión"
                            normalize={(v) => decimalNormalizer(v)}
                          >
                            <Input allowClear />
                          </Form.Item>
                        </Col> */}
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="valor_catastral"
                            label="Valor fiscal"
                          >
                            <Input disabled={!permission.editar_tab_transmision || !mutable} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            label="Área Título"
                            name="area_titulo"
                            onChange={(area_titulo) => formValoresMedidas
                              .setFieldValue({ area_titulo })}
                            precision={3}
                            decimal
                            disabled={!permission.editar_area_titulo || !mutable}
                            commas
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="fecha_traslado"
                            label="Fecha de otorgamiento"
                          >
                            <DatePicker
                              placeholder=""
                              format={DATE_FRONTEND_FORMAT}
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="fecha_adjudicacion_traslado"
                            label="Fecha de adjudicación"
                          >
                            <DatePicker
                              placeholder=""
                              format={DATETIME_FRONTEND_FORMAT}
                              showTime
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="fecha_de_celebracion"
                            label="Fecha de firmas"
                          >
                            <DatePicker
                              placeholder=""
                              format={DATETIME_FRONTEND_FORMAT}
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="valor_operacion_traslado"
                            label="Valor de la operación"
                            normalize={(v) => decimalNormalizer(v)}
                          >
                            <Input
                              allowClear
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tasa_marginal"
                            label="Tasa marginal"
                          >
                            <Input
                              allowClear
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            name="numero_de_inscripcion_registro_publico"
                            label="Folio RPP"
                            disabled={!permission.editar_tab_transmision || !mutable}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            name="anio_referido_traslado"
                            label="Año referido"
                            maxLength={4}
                            minLength={4}
                            disabled={!permission.editar_tab_transmision || !mutable}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            name="bimestre_referido_traslado"
                            label="Bim referido"
                            min={1}
                            max={6}
                            disabled={!permission.editar_tab_transmision || !mutable}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            name="observaciones_traslado"
                            label="Observaciones"
                          >
                            <Input.TextArea
                              allowClear
                              autoSize={{ minRows: 3 }}
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="esta_exento"
                            label="Exento"
                          >
                            <Select
                              trueFalse
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        {/* <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_tasa_referencial"
                            label="Aplica tasa referencial"
                          >
                            <Select trueFalse />
                          </Form.Item>
                        </Col> */}
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="omitir_valores_referenciados"
                            label="Omitir valores referenciados"
                          >
                            <Select
                              trueFalse
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="valor_base_traslado"
                            label="Valor base"
                            normalize={(v) => decimalNormalizer(v)}
                          >
                            <Input
                              allowClear
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="factor_traslado"
                            label="Factor"
                          >
                            <Select
                              dataSource={factoresDeTraslado}
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_valuacion"
                            label="Tipo de valuación"
                          >
                            <Select
                              dataSource={tiposDeValuacion}
                              onChange={(tipo_de_valuacion) => form
                                .setFieldsValue({ tipo_de_valuacion })}
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_cuenta"
                            label="Tipo de cuenta"
                          >
                            <Select
                              dataSource={tiposDeCuentas}
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            name="porcentaje_traslado"
                            label="Porcentaje total de la transmisión"
                            min={0}
                            max={100}
                            decimal
                            disabled={!permission.editar_tab_transmision || !mutable}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="remplaza_regimenes"
                            label="Remplaza regímenes"
                          >
                            <Select
                              trueFalse
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="notario_contribuyente"
                            label="Notario"
                          >
                            <Select
                              dataSource={notarios}
                              onChange={onChangeNotario}
                              disabled={!permission.editar_tab_transmision || !mutable}
                              keyLabelRender
                              labelProp="nombre_completo"
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="uso_de_predio"
                            label="Uso de suelo"
                          >
                            <Select
                              dataSource={usosDePredio}
                              disabled={!permission.editar_tab_transmision || !mutable}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Form.Item hidden>
                        <Button htmlType="submit" />
                      </Form.Item>
                    </Form>
                  </TabPane>
                </Tabs>
              </Card>
            </Col>
          )}
        </Spin>
      </Col>
      <Modal
        open={verHistorial || verHistorialPrevio}
        title={(
          <FormSubmitControls
            label={`Historial ${verHistorialPrevio ? 'previo ' : ''}del predio`}
            onCancel={() => {
              setVerHistorial(false);
              setVerHistorialPrevio(false);
            }}
          />
        )}
        onCancel={() => {
          setVerHistorial(false);
          setVerHistorialPrevio(false);
        }}
        footer={null}
        width={screens?.md ? 920 : '95%'}
        destroyOnClose
        closable={false}
      >
        {verHistorial && <HistorialDeTramites predio={selectedRowKeys[0]} />}
        {verHistorialPrevio && <HistorialPrevioDeTramites predio={selectedRowKeys[0]} />}
      </Modal>
      <Previewer
        visible={!!base64}
        base64={base64}
        setVisible={() => setBase64()}
        isImage={false}
        allowDownload
      />
    </Row>
  );
};

const Result = styled(AntResult)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default Predios;
